var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen10Form(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 780",
    width: 360,
    height: 780,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 780,
    fill: "#0c1218"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 34,
    height: 9,
    rx: 4.5,
    fill: "#dfe6e8",
    opacity: 0.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 19,
    width: 18,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 304,
    y: 19,
    width: 14,
    height: 8,
    rx: 2,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 18,
    width: 20,
    height: 10,
    rx: 3,
    fill: "#dfe6e8",
    opacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 12,
    width: 100,
    height: 24,
    rx: 12,
    fill: "#000",
    opacity: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 56,
    width: 70,
    height: 7,
    rx: 3.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 72,
    width: 130,
    height: 16,
    rx: 8,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 110,
    width: 320,
    height: 150,
    rx: 18,
    fill: "#141d27",
    opacity: 1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 134,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 142,
    width: 170,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 174,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 182,
    width: 150,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 214,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#1a2531",
    opacity: 1
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 222,
    width: 130,
    height: 8,
    rx: 4,
    fill: "#4b5a68",
    opacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52,154 L52,174",
    stroke: "#5ce1e6",
    strokeWidth: 3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 282,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 296,
    width: 320,
    height: 46,
    rx: 10,
    fill: "#0c1218",
    opacity: 1
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 296.5,
    width: 319,
    height: 45,
    rx: 10,
    fill: "none",
    opacity: 1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 296.5,
    width: 319,
    height: 45,
    rx: 10,
    fill: "none",
    stroke: "#233142",
    strokeWidth: 1.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 315,
    width: 138,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 0.85
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 356,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 370,
    width: 320,
    height: 46,
    rx: 10,
    fill: "#0c1218",
    opacity: 1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 370.5,
    width: 319,
    height: 45,
    rx: 10,
    fill: "none",
    opacity: 1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 370.5,
    width: 319,
    height: 45,
    rx: 10,
    fill: "none",
    stroke: "#5ce1e6",
    strokeWidth: 2
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 389,
    width: 111,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 0.85
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 430,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 444,
    width: 320,
    height: 46,
    rx: 10,
    fill: "#0c1218",
    opacity: 1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 444.5,
    width: 319,
    height: 45,
    rx: 10,
    fill: "none",
    opacity: 1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 444.5,
    width: 319,
    height: 45,
    rx: 10,
    fill: "none",
    stroke: "#233142",
    strokeWidth: 1.5
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 463,
    width: 131,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 0.85
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 504,
    width: 80,
    height: 6,
    rx: 3,
    fill: "#4b5a68",
    opacity: 1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 518,
    width: 320,
    height: 46,
    rx: 10,
    fill: "#0c1218",
    opacity: 1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 518.5,
    width: 319,
    height: 45,
    rx: 10,
    fill: "none",
    opacity: 1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 518.5,
    width: 319,
    height: 45,
    rx: 10,
    fill: "none",
    stroke: "#233142",
    strokeWidth: 1.5
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 537,
    width: 105,
    height: 8,
    rx: 4,
    fill: "#dfe6e8",
    opacity: 0.85
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 590,
    width: 320,
    height: 58,
    rx: 16,
    fill: "#141d27",
    opacity: 1
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 610,
    width: 70,
    height: 7,
    rx: 3.5,
    fill: "#4b5a68",
    opacity: 1
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 606,
    width: 70,
    height: 14,
    rx: 7,
    fill: "#dfe6e8",
    opacity: 1
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 666,
    width: 320,
    height: 56,
    rx: 28,
    fill: "#5ce1e6",
    opacity: 1
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 690,
    width: 88,
    height: 9,
    rx: 4.5,
    fill: "#05070a",
    opacity: 1
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 766,
    width: 120,
    height: 5,
    rx: 2.5,
    fill: "#dfe6e8",
    opacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen10Form);
export default __webpack_public_path__ + "static/media/screen-10-form.bc5c3b4f1136cac0c9866dec37b7190b.svg";
export { ForwardRef as ReactComponent };